import { createSlice } from '@reduxjs/toolkit'
import { CommissionState } from './types'
import { CommissionService } from '../../services/commission/CommissionService'

const initialState: CommissionState = {
  //state

  isGetAllCommissionsLoading: false,
  isExportCommissionsLoading: false,
  isGetCommissionByDealerIdLoading: false,
  isCreateCommissionLoading: false,
  isUpdateCommissionLoading: false,
  isDeleteCommissionLoading: false,
  isGetCommissionTransactionsByDealerIdLoading: false,
  isUpdateStatusCommissionTransactionsLoading: false,
  isGetCommissionSummaryByDealerIdLoading: false,
  isSaveCommissionSummaryLoading: false,
  isApproveCommissionSummaryLoading: false,
  isGetCommissionDealerInfoLoading: false,
  isImportCommissionLoading: false,
  isDownloadCommissionTemplateLoading: false
}

const slice = createSlice({
  name: 'commission',
  initialState,
  reducers: {
    resetCommissionState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(CommissionService.getAllCommissionsAsyncThunk.pending, (state) => {
        state.isGetAllCommissionsLoading = true
      })
      .addCase(CommissionService.getAllCommissionsAsyncThunk.rejected, (state) => {
        state.isGetAllCommissionsLoading = false
      })
      .addCase(CommissionService.getAllCommissionsAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllCommissionsLoading = false
        state.fetchedAllCommissions = action.payload
      })
      .addCase(CommissionService.exportCommissionsAsyncThunk.pending, (state) => {
        state.isExportCommissionsLoading = true
      })
      .addCase(CommissionService.exportCommissionsAsyncThunk.rejected, (state) => {
        state.isExportCommissionsLoading = false
      })
      .addCase(CommissionService.exportCommissionsAsyncThunk.fulfilled, (state) => {
        state.isExportCommissionsLoading = false
      })
      .addCase(CommissionService.getCommissionByDealerIdAsyncThunk.pending, (state) => {
        state.isGetCommissionByDealerIdLoading = true
      })
      .addCase(CommissionService.getCommissionByDealerIdAsyncThunk.rejected, (state) => {
        state.isGetCommissionByDealerIdLoading = false
      })
      .addCase(CommissionService.getCommissionByDealerIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetCommissionByDealerIdLoading = false
        state.fetchedCommissionByDealerId = action.payload
        state.commissionTimestamp = action.payload.commission
      })
      .addCase(CommissionService.createCommissionAsyncThunk.pending, (state) => {
        state.isCreateCommissionLoading = true
      })
      .addCase(CommissionService.createCommissionAsyncThunk.rejected, (state) => {
        state.isCreateCommissionLoading = false
      })
      .addCase(CommissionService.createCommissionAsyncThunk.fulfilled, (state) => {
        state.isCreateCommissionLoading = false
      })
      .addCase(CommissionService.updateCommissionAsyncThunk.pending, (state) => {
        state.isUpdateCommissionLoading = true
      })
      .addCase(CommissionService.updateCommissionAsyncThunk.rejected, (state) => {
        state.isUpdateCommissionLoading = false
      })
      .addCase(CommissionService.updateCommissionAsyncThunk.fulfilled, (state) => {
        state.isUpdateCommissionLoading = false
      })
      .addCase(CommissionService.deleteCommissionAsyncThunk.pending, (state) => {
        state.isDeleteCommissionLoading = true
      })
      .addCase(CommissionService.deleteCommissionAsyncThunk.rejected, (state) => {
        state.isDeleteCommissionLoading = false
      })
      .addCase(CommissionService.deleteCommissionAsyncThunk.fulfilled, (state) => {
        state.isDeleteCommissionLoading = false
      })
      .addCase(CommissionService.getCommissionTransactionsByDealerIdAsyncThunk.pending, (state) => {
        state.isGetCommissionTransactionsByDealerIdLoading = true
      })
      .addCase(CommissionService.getCommissionTransactionsByDealerIdAsyncThunk.rejected, (state) => {
        state.isGetCommissionTransactionsByDealerIdLoading = false
      })
      .addCase(CommissionService.getCommissionTransactionsByDealerIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetCommissionTransactionsByDealerIdLoading = false
        state.fetchedCommissionTransactionsByDealerId = action.payload
      })
      .addCase(CommissionService.updateStatusCommissionTransactionsAsyncThunk.pending, (state) => {
        state.isUpdateStatusCommissionTransactionsLoading = true
      })
      .addCase(CommissionService.updateStatusCommissionTransactionsAsyncThunk.rejected, (state) => {
        state.isUpdateStatusCommissionTransactionsLoading = false
      })
      .addCase(CommissionService.updateStatusCommissionTransactionsAsyncThunk.fulfilled, (state) => {
        state.isUpdateStatusCommissionTransactionsLoading = false
      })
      .addCase(CommissionService.getCommissionSummaryByDealerIdAsyncThunk.pending, (state) => {
        state.isGetCommissionSummaryByDealerIdLoading = true
      })
      .addCase(CommissionService.getCommissionSummaryByDealerIdAsyncThunk.rejected, (state) => {
        state.isGetCommissionSummaryByDealerIdLoading = false
      })
      .addCase(CommissionService.getCommissionSummaryByDealerIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetCommissionSummaryByDealerIdLoading = false
        state.fetchedCommissionSummaryByDealerId = action.payload
      })
      .addCase(CommissionService.saveCommissionSummaryAsyncThunk.pending, (state) => {
        state.isSaveCommissionSummaryLoading = true
      })
      .addCase(CommissionService.saveCommissionSummaryAsyncThunk.rejected, (state) => {
        state.isSaveCommissionSummaryLoading = false
      })
      .addCase(CommissionService.saveCommissionSummaryAsyncThunk.fulfilled, (state) => {
        state.isSaveCommissionSummaryLoading = false
      })
      .addCase(CommissionService.approveCommissionSummaryAsyncThunk.pending, (state) => {
        state.isApproveCommissionSummaryLoading = true
      })
      .addCase(CommissionService.approveCommissionSummaryAsyncThunk.rejected, (state) => {
        state.isApproveCommissionSummaryLoading = false
      })
      .addCase(CommissionService.approveCommissionSummaryAsyncThunk.fulfilled, (state) => {
        state.isApproveCommissionSummaryLoading = false
      })
      .addCase(CommissionService.getCommissionDealerInfoAsyncThunk.pending, (state) => {
        state.isGetCommissionDealerInfoLoading = true
      })
      .addCase(CommissionService.getCommissionDealerInfoAsyncThunk.rejected, (state) => {
        state.isGetCommissionDealerInfoLoading = false
      })
      .addCase(CommissionService.getCommissionDealerInfoAsyncThunk.fulfilled, (state, action) => {
        state.isGetCommissionDealerInfoLoading = false
        state.fetchedCommissionDealerInfo = action.payload
        state.commissionTimestamp = action.payload
      })
      .addCase(CommissionService.importCommissionAsyncThunk.pending, (state) => {
        state.isImportCommissionLoading = true
      })
      .addCase(CommissionService.importCommissionAsyncThunk.rejected, (state) => {
        state.isImportCommissionLoading = false
      })
      .addCase(CommissionService.importCommissionAsyncThunk.fulfilled, (state) => {
        state.isImportCommissionLoading = false
      })
      .addCase(CommissionService.downloadCommissionTemplateAsyncThunk.pending, (state) => {
        state.isDownloadCommissionTemplateLoading = true
      })
      .addCase(CommissionService.downloadCommissionTemplateAsyncThunk.rejected, (state) => {
        state.isDownloadCommissionTemplateLoading = false
      })
      .addCase(CommissionService.downloadCommissionTemplateAsyncThunk.fulfilled, (state) => {
        state.isDownloadCommissionTemplateLoading = false
      })
  }
})

export const { resetCommissionState } = slice.actions
export default slice.reducer
